/** Admin roles that can assign and use browser phone. */
export const PHONE_ADMIN_ROLES = new Set(['superadmin', 'admin', 'tenant_admin']);

/** @returns {boolean} */
export function isPhoneEnabledForUser(userData, role) {
  const resolvedRole = String(role || userData?.role || '').trim().toLowerCase();
  if (PHONE_ADMIN_ROLES.has(resolvedRole)) return true;
  return Boolean(userData?.permissions?.phoneEnabled);
}
